"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisallowedIdentifier = exports.VariableRedeclaration = exports.NotEnoughArguments = exports.InvalidNumberOfArguments = exports.UnassignedVariable = exports.UndefinedVariable = exports.CallingNonFunctionValue = exports.MaximumStackLimitExceeded = exports.UnreachableCodeReached = exports.UnexpectedDottedList = exports.UnquoteSplicingInNonListContext = exports.UnquoteSplicingEvaluatedToNonList = exports.UnquoteInWrongContext = exports.UnexpectedQuotationError = exports.BuiltinProcedureError = exports.MacroExpansionError = exports.DefMacroSyntaxError = exports.QuoteSyntaxError = exports.BeginSyntaxError = exports.CondProcedureClauseError = exports.CondSyntaxError = exports.LetSyntaxError = exports.IfSyntaxError = exports.SetSyntaxError = exports.LambdaSyntaxError = exports.DefineSyntaxError = void 0;
/* tslint:disable: max-classes-per-file */
const util_1 = require("../interpreter/util");
const stringify_1 = require("../utils/stringify");
const runtimeSourceError_1 = require("./runtimeSourceError");
class DefineSyntaxError extends runtimeSourceError_1.RuntimeSourceError {
    constructor(node) {
        super(node);
    }
    explain() {
        return ("Syntax for `define' is incorrect. Please use `(define variable value)', " +
            "`(define (procedureName arg ...) body1 body2...)', or " +
            "`(define (procedureName arg ... . rest-args) body1 body2...)'");
    }
}
exports.DefineSyntaxError = DefineSyntaxError;
class LambdaSyntaxError extends runtimeSourceError_1.RuntimeSourceError {
    constructor(node) {
        super(node);
    }
    explain() {
        return ("Syntax for `lambda' is incorrect. Please use `(lambda (arg ...) body1 body2 ...)', " +
            "`(lambda (arg1 arg2 ... . rest-args) body1 body2 ...)', or " +
            "`(lambda args body1 body2 ...)'.");
    }
}
exports.LambdaSyntaxError = LambdaSyntaxError;
class SetSyntaxError extends runtimeSourceError_1.RuntimeSourceError {
    constructor(node) {
        super(node);
    }
    explain() {
        return "Syntax for `set!' is incorrect. Please use `(set! variable value) body)'";
    }
}
exports.SetSyntaxError = SetSyntaxError;
class IfSyntaxError extends runtimeSourceError_1.RuntimeSourceError {
    constructor(node) {
        super(node);
    }
    explain() {
        return "Syntax for `if' is incorrect. Please use `(if (test) (consequent))' or `(if (test) (consequent) (alternative))'";
    }
}
exports.IfSyntaxError = IfSyntaxError;
class LetSyntaxError extends runtimeSourceError_1.RuntimeSourceError {
    constructor(node) {
        super(node);
    }
    explain() {
        return "Syntax for `let' is incorrect. Please use `(if ((name value) ...) body1 body2 ...)'";
    }
}
exports.LetSyntaxError = LetSyntaxError;
class CondSyntaxError extends runtimeSourceError_1.RuntimeSourceError {
    constructor(node) {
        super(node);
    }
    explain() {
        return ("Syntax for `cond' is incorrect. " +
            "Please use `(cond clause1 clause2 ...)', " +
            'where a clause is either ' +
            "`(test expression ...), (test => expression), or (else expression1 expression2 ...)' " +
            'An else clause must be the last clause of the expression.');
    }
}
exports.CondSyntaxError = CondSyntaxError;
class CondProcedureClauseError extends runtimeSourceError_1.RuntimeSourceError {
    constructor(node) {
        super(node);
    }
    explain() {
        return 'expression in (test => expression) in a cond expression must evaluate to a procedure';
    }
}
exports.CondProcedureClauseError = CondProcedureClauseError;
class BeginSyntaxError extends runtimeSourceError_1.RuntimeSourceError {
    constructor(node) {
        super(node);
    }
    explain() {
        return "Syntax for `begin' is incorrect. Please use `(begin expression1 expression2 ...)'.";
    }
}
exports.BeginSyntaxError = BeginSyntaxError;
const quoteTypeToShorthand = (type) => {
    switch (type) {
        case 'quote':
            return "'";
        case 'quasiquote':
            return '`';
        case 'unquote':
            return ',';
        case 'unquote-splicing':
            return ',@';
    }
};
class QuoteSyntaxError extends runtimeSourceError_1.RuntimeSourceError {
    constructor(quoteType, node) {
        super(node);
        this.quoteType = quoteType;
    }
    explain() {
        return `Syntax for \`${this.quoteType}' is incorrect. Please use (${this.quoteType} expression) or ${quoteTypeToShorthand(this.quoteType)}expression`;
    }
}
exports.QuoteSyntaxError = QuoteSyntaxError;
class DefMacroSyntaxError extends runtimeSourceError_1.RuntimeSourceError {
    constructor(node) {
        super(node);
    }
    explain() {
        return "Syntax for `set!' is incorrect. Please use `(set! variable value) body)'";
    }
}
exports.DefMacroSyntaxError = DefMacroSyntaxError;
class MacroExpansionError extends runtimeSourceError_1.RuntimeSourceError {
    constructor(expandedResult, node) {
        super(node);
        this.expandedResult = expandedResult;
    }
    explain() {
        return `A macro must expand to a value convertible to an S-expression, but got ${this.expandedResult.type}.`;
    }
}
exports.MacroExpansionError = MacroExpansionError;
class BuiltinProcedureError extends runtimeSourceError_1.RuntimeSourceError {
    constructor(cause, node) {
        super(node);
        this.cause = cause;
    }
    explain() {
        return this.cause.message;
    }
}
exports.BuiltinProcedureError = BuiltinProcedureError;
class UnexpectedQuotationError extends runtimeSourceError_1.RuntimeSourceError {
    constructor(node) {
        super(node);
    }
    explain() {
        return `Unexpected quotation`;
    }
}
exports.UnexpectedQuotationError = UnexpectedQuotationError;
class UnquoteInWrongContext extends runtimeSourceError_1.RuntimeSourceError {
    constructor(node) {
        super(node);
    }
    explain() {
        return `\`unquote' and \`unquote-splicing' can only appear within quasiquotations with right level of depth`;
    }
}
exports.UnquoteInWrongContext = UnquoteInWrongContext;
class UnquoteSplicingEvaluatedToNonList extends runtimeSourceError_1.RuntimeSourceError {
    constructor(result, node) {
        super(node);
        this.result = result;
    }
    explain() {
        return `\`unquote-splicing' should evaluate to a list, but evaluated to ${this.result.type}`;
    }
}
exports.UnquoteSplicingEvaluatedToNonList = UnquoteSplicingEvaluatedToNonList;
class UnquoteSplicingInNonListContext extends runtimeSourceError_1.RuntimeSourceError {
    constructor(node) {
        super(node);
    }
    explain() {
        return `\`unquote-splicing' can only appear within a list`;
    }
}
exports.UnquoteSplicingInNonListContext = UnquoteSplicingInNonListContext;
class UnexpectedDottedList extends runtimeSourceError_1.RuntimeSourceError {
    constructor(node) {
        super(node);
    }
    explain() {
        return 'Unexpected dotted list';
    }
}
exports.UnexpectedDottedList = UnexpectedDottedList;
class UnreachableCodeReached extends runtimeSourceError_1.RuntimeSourceError {
    constructor(message) {
        super();
        this.message = message;
    }
    explain() {
        return `Unreachable code reached: ${this.message}`;
    }
}
exports.UnreachableCodeReached = UnreachableCodeReached;
class MaximumStackLimitExceeded extends runtimeSourceError_1.RuntimeSourceError {
    constructor(node, calls) {
        super(node);
        this.calls = calls;
    }
    explain() {
        return 'Maximum call stack size exceeded\n  ' + this.calls.join('  ');
    }
}
exports.MaximumStackLimitExceeded = MaximumStackLimitExceeded;
MaximumStackLimitExceeded.MAX_CALLS_TO_SHOW = 3;
class CallingNonFunctionValue extends runtimeSourceError_1.RuntimeSourceError {
    constructor(callee, node) {
        super(node);
        this.callee = callee;
        this.node = node;
    }
    explain() {
        return `Calling non-function value ${stringify_1.stringify(this.callee)}.`;
    }
}
exports.CallingNonFunctionValue = CallingNonFunctionValue;
class UndefinedVariable extends runtimeSourceError_1.RuntimeSourceError {
    constructor(name, node) {
        super(node);
        this.name = name;
    }
    explain() {
        return `Name ${this.name} not declared.`;
    }
    elaborate() {
        return `Before you can read the value of ${this.name}, you need to declare it as a variable or a constant. You can do this using the let or const keywords.`;
    }
}
exports.UndefinedVariable = UndefinedVariable;
class UnassignedVariable extends runtimeSourceError_1.RuntimeSourceError {
    constructor(name, node) {
        super(node);
        this.name = name;
    }
    explain() {
        return `Name ${this.name} declared later in current scope but not yet assigned`;
    }
    elaborate() {
        return `If you're trying to access the value of ${this.name} from an outer scope, please rename the inner ${this.name}. An easy way to avoid this issue in future would be to avoid declaring any variables or constants with the name ${this.name} in the same scope.`;
    }
}
exports.UnassignedVariable = UnassignedVariable;
class InvalidNumberOfArguments extends runtimeSourceError_1.RuntimeSourceError {
    constructor(node, signatureString, expected, got) {
        super(node);
        this.signatureString = signatureString;
        this.expected = expected;
        this.got = got;
    }
    explain() {
        return `${this.signatureString} expected ${this.expected} arguments, but got ${this.got}.`;
    }
    elaborate() {
        const pluralS = this.expected === 1 ? '' : 's';
        return `Try calling procedure ${this.signatureString} again, but with ${this.expected} argument${pluralS} instead.`;
    }
}
exports.InvalidNumberOfArguments = InvalidNumberOfArguments;
class NotEnoughArguments extends runtimeSourceError_1.RuntimeSourceError {
    constructor(node, signatureString, expected, got) {
        super(node);
        this.signatureString = signatureString;
        this.expected = expected;
        this.got = got;
    }
    explain() {
        return `${this.signatureString} expected at least ${this.expected} arguments, but got ${this.got}.`;
    }
    elaborate() {
        const pluralS = this.expected === 1 ? '' : 's';
        return `Try calling procedure ${this.signatureString} again, but with at least ${this.expected} argument${pluralS} instead.`;
    }
}
exports.NotEnoughArguments = NotEnoughArguments;
class VariableRedeclaration extends runtimeSourceError_1.RuntimeSourceError {
    constructor(node, name, writable) {
        super(node);
        this.node = node;
        this.name = name;
        this.writable = writable;
    }
    explain() {
        return `Redeclaring name ${this.name}.`;
    }
    elaborate() {
        if (this.writable === true) {
            const elabStr = `Since ${this.name} has already been declared, you can assign a value to it without re-declaring.`;
            const initStr = '';
            // To temporarily silence ts warning
            this.node;
            // if (this.node.type === 'FunctionDeclaration') {
            //   initStr =
            //     '(' + (this.node as es.FunctionDeclaration).params.map(generate).join(',') + ') => {...'
            // } else if (this.node.type === 'VariableDeclaration') {
            //   initStr = generate((this.node as es.VariableDeclaration).declarations[0].init)
            // }
            return `${elabStr} As such, you can just do\n\n\t${this.name} = ${initStr};\n`;
        }
        else if (this.writable === false) {
            return `You will need to declare another variable, as ${this.name} is read-only.`;
        }
        else {
            return '';
        }
    }
}
exports.VariableRedeclaration = VariableRedeclaration;
class DisallowedIdentifier extends runtimeSourceError_1.RuntimeSourceError {
    constructor(name, node) {
        super(node);
        this.name = name;
    }
    explain() {
        return `'${this.name}' cannot be used as an identifier because user identifiers cannot start with ${util_1.syntheticIdentifierPrefix}`;
    }
}
exports.DisallowedIdentifier = DisallowedIdentifier;
//# sourceMappingURL=errors.js.map